import React, { useEffect, useRef, useState } from "react";
import logo from "../../image/Salarytap_social_profile.png";
import { Link, useNavigate } from "react-router-dom";
import "./index.css";
import Profile from "./Page/Profile";

import Setting from "./Page/Setting";
import ManageEmploye from "./Page/ManageEmploye";
import TalkToSales from "./Page/TalkToSales";
import Admin from "./Page/Admin";
import CreateCorporateWorkspace from "./Page/CreateCorporateWorkspace";
import { APIURL } from "../../Config";
import axios from "axios";
import AssuranceAgreement from "./Page/AssuranceAgreement";
import Support from "./Page/Support";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAppContext } from "../utils/Appcontex";

export default function SideBar() {
  const history = useNavigate();
  const token = localStorage.getItem("token");
  const workspaceId = localStorage.getItem("workspace");
  const emailid = localStorage.getItem("emailId");
  const loginTime = localStorage.getItem("loginTime");

  // const [activeIndex, setActiveIndex] = useState(5);
  // const [key, setKey] = useState("ManageEmployees");
  const [activeTab, setActiveTab] = useState("profile");
  const [workSpace, SetWorkSpace] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { setOpen, key, setKey, activeIndex, setActiveIndex } = useAppContext();

  useEffect(() => {
    const interval = setInterval(() => {
      console.log("This message logs every 10 seconds.", loginTime);
      const SIX_HOURS = 6 * 60 * 60 * 1000;
      if (loginTime && Date.now() - loginTime > SIX_HOURS) {
        SignOut();
        clearInterval(interval); // Stop further checks
      }
    }, 10000); // 10000 ms = 10 seconds

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  const handleClick = (index, tabKey, tabId) => {
    setActiveIndex(index);
    setKey(tabKey);
    setActiveTab(tabId);
    if (window.innerWidth <= 768) {
      setSidebarVisible(false);
    }
  };
  const loginData = {
    email: emailid,
    loginstatus: "false",
  };

  const loginUpdate = () => {
    axios
      .request(`${APIURL}/loginupdate`, {
        method: "POST",
        data: loginData,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response login update::", response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const SignOut = () => {
    history("/");
    loginUpdate();
    localStorage.clear();
  };

  React.useEffect(() => {
    if (!token == "") {
      history("/salarytap/dashboard");
      WorkspaceDetails();
    } else {
      history("/salarytap/login");
      localStorage.clear();
    }
  }, []);

  function WorkspaceDetails() {
    const data = { emailid, workspaceId };
    setIsLoader(true);
    axios
      .request(`${APIURL}/corporate/getprofiledetails`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        SetWorkSpace(response?.data);
        localStorage.setItem("corpadminmail", response?.data?.corpadminmail);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  console.log("workSpace", workSpace);
  const [selectedImage, setSelectedImage] = useState("");
  const fileInputRef = useRef(null);
  const [previewError, setPreviewError] = useState(false);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setSelectedImage(file);
      setPreviewError(false);
    } else {
      setSelectedImage(null);
      setPreviewError(true);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!selectedImage) {
      setPreviewError(true);
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedImage);
    formData.append("emailid", emailid);
    formData.append("ownerEmail", emailid);
    console.log("formData", formData);
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }
    setIsLoader(true);
    axios
      .request(`${APIURL}/corporate/uploadlogo`, {
        method: "POST",
        data: formData,
        headers: {
          Authentication: token,
        },
      })
      .then((response) => {
        setIsLoader(false);
        console.log("response", response);
        setShowModal(false);
        WorkspaceDetails();
        toast.success("Uploaded..");
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoader(false);
        setShowModal(false);
        toast.warning("User does not exist...");
      });
  };

  const handleModalClose = () => {
    setSelectedImage("");
    setShowModal(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth > 768) {
        setSidebarVisible(true);
      } else {
        setSidebarVisible(false);
      }
    };
    setIsMobile(window.innerWidth < 768);
    if (window.innerWidth < 768) {
      setSidebarVisible(false);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="d-flex  bg-light">
        {sidebarVisible && (
          <div
            className="flex-column flex-shrink-0 p-3 border sidebar-toggle"
            style={{
              width: 280,
              height: "100vh",
              display: "flex",
              background: "#fff",
              position: "sticky",
              top: "0",
            }}
          >
            <div
              className="d-flex"
              style={{
                justifyContent: "center",
                alignItems: "start",
                flexDirection: "column",
              }}
            >
              <div
                className="border"
                style={{
                  borderRadius: "50%",
                  height: "80px",
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {isLoader ? (
                  ""
                ) : workSpace?.url ? (
                  <img
                    src={workSpace?.url}
                    style={{
                      width: "100%",
                      objectFit: "contain",
                      height: "100%",
                    }}
                  />
                ) : (
                  <>
                    <img
                      src={logo}
                      style={{
                        width: "100%",
                        objectFit: "cover",
                        height: "100%",
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-secondary pt-0"
                      style={{
                        position: "absolute",
                        bottom: "-8px",
                        width: "100%",
                        backgroundColor: "#6C757D",
                        color: "#fff",
                        border: "none",
                        zIndex: 1,
                        borderRadius: "0px",
                      }}
                      onClick={() => setShowModal(true)}
                    >
                      Edit
                    </button>
                  </>
                )}
              </div>
            </div>
            <Modal show={showModal} onHide={handleModalClose}>
              <Modal.Body closeButton>
                <Form onSubmit={handleSubmit}>
                  <Form.Group controlId="formFile">
                    <Form.Label>
                      <h5>Choose a Logo</h5>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      ref={fileInputRef}
                      name="image"
                    />
                  </Form.Group>
                  <div className="d-flex">
                    <Button
                      variant="secondary"
                      className="mt-3 border"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </Button>
                    <Button
                      variant="success"
                      type="submit"
                      className="mt-3 border"
                      style={{ backgroundColor: "#66a725" }}
                    >
                      {isLoader ? (
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                </Form>
              </Modal.Body>
            </Modal>

            <hr />
            <ul className="nav nav-pills flex-column mb-auto">
              <li
                className={`nav-link nav-itm mb-1 ${
                  activeIndex === 0 ? "active" : ""
                }`}
                onClick={() => {
                  handleClick(0);
                  setKey("Profile");
                  setOpen(false);
                }}
                style={{
                  backgroundColor:
                    activeIndex === 0 ? "#a6df6d" : "transparent",
                  color: activeIndex === 0 ? "#000" : "#000",
                  cursor: "pointer",
                }}
              >
                {workSpace?.model !== null && workSpace?.address !== null ? (
                  // workSpace?.companyType !== null &&
                  // workSpace?.hrApp !== null &&
                  "Profile"
                ) : (
                  <p
                    className="m-0"
                    style={{
                      color: "red",
                    }}
                  >
                    Complete your profile &nbsp;&nbsp;
                    <i className="fa-solid fa-circle-exclamation" />
                  </p>
                )}
              </li>
              <li
                className={`nav-link nav-itm  mb-1 ${
                  activeIndex === 1 ? "active" : ""
                }`}
                onClick={() => {
                  handleClick(1);
                  setKey("Admin");
                }}
                style={{
                  backgroundColor:
                    activeIndex === 1 ? "#a6df6d" : "transparent",
                  color: activeIndex === 1 ? "#000" : "#000",
                  cursor: "pointer",
                }}
              >
                Employer Workspace Admin
              </li>

              <li
                className={`nav-link nav-itm  mb-1 ${
                  activeIndex === 5 ? "active" : ""
                }`}
                onClick={() => {
                  handleClick(5);
                  setKey("ManageEmployees");
                }}
                style={{
                  backgroundColor:
                    activeIndex === 5 ? "#a6df6d" : "transparent",
                  color: activeIndex === 5 ? "#000" : "#000",
                  cursor: "pointer",
                }}
              >
                Manage Employees
              </li>
              <li
                className={`nav-link nav-itm  mb-1 ${
                  activeIndex === 6 ? "active" : ""
                }`}
                onClick={() => {
                  handleClick(6);
                  setKey("AssuranceAgreement");
                }}
                style={{
                  backgroundColor:
                    activeIndex === 6 ? "#a6df6d" : "transparent",
                  color: activeIndex === 6 ? "#000" : "#000",
                  cursor: "pointer",
                }}
              >
                {workSpace?.assuranceTc ? (
                  "Assurance Agreement"
                ) : (
                  <p
                    className="m-0"
                    style={{
                      color: "red",
                    }}
                  >
                    Sign Your Assurance Agreement &nbsp;&nbsp;
                    <i className="fa-solid fa-circle-exclamation" />
                  </p>
                )}
              </li>
              <li
                className={`nav-link nav-itm  mb-1 ${
                  activeIndex === 7 ? "active" : ""
                }`}
                onClick={() => {
                  handleClick(7);
                  setKey("Support");
                }}
                style={{
                  backgroundColor:
                    activeIndex === 7 ? "#a6df6d" : "transparent",
                  color: activeIndex === 7 ? "#000" : "#000",
                  cursor: "pointer",
                }}
              >
                Support
              </li>
            </ul>
            <hr />
            <li
              className="nav-link nav-itm text-black mb-1"
              style={{
                padding: "8px 24px",
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onClick={() => SignOut()}
            >
              Log Out
            </li>
          </div>
        )}
        <div
          className="container-fluid flex-grow-1 p-3"
          style={{ height: "auto" }}
        >
          {isMobile ? (
            <>
              <div
                className="d-flex"
                style={{ justifyContent: "space-between" }}
              >
                <div
                  className=" px-2 py-1"
                  style={{
                    background: "transparent",
                    color: "#000",
                    cursor: "pointer",
                    border: "1px solid #0000002d",
                    borderRadius: "8px",
                  }}
                  onClick={() => setSidebarVisible(!sidebarVisible)}
                >
                  {sidebarVisible ? (
                    <i className="fa-solid fa-xmark" />
                  ) : (
                    <i className="fa-solid fa-bars-staggered" />
                  )}
                </div>
                <div className="d-flex justify-content-end mr-4">
                  {!isLoader && (
                    <div>
                      <h5 className="m-0" style={{ color: "#000" }}>
                        {workSpace?.companyName || "Company Name"}Workspace
                      </h5>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="d-flex justify-content-end">
                <div className="d-flex justify-content-end mr-4">
                  {!isLoader && (
                    <div>
                      <h5 className="m-0" style={{ color: "#000" }}>
                        {workSpace?.companyName || "Company Name"} Workspace
                      </h5>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          <div className="">
            {key === "Profile" && <Profile props={workSpace} />}
            {key === "Admin" && <Admin props={workSpace} />}
            {key === "AssuranceAgreement" && <AssuranceAgreement />}
            {key === "Setting" && <Setting />}
            {key === "CreateCorporateWorkspace" && <CreateCorporateWorkspace />}
            {key === "ManageEmployees" && (
              <ManageEmploye workSpace={workSpace} />
            )}
            {key === "TalkToSales" && <TalkToSales />}
            {key === "Support" && <Support />}
          </div>
        </div>
      </div>
    </>
  );
}
